<template>
  <ContentLayout
    widthClass="max-1000"
    pad="0"
    :title="
      iSEdited
        ? $t('label_essweb_eventPropertyGroup_form_editTitle')
        : $t('label_essweb_eventPropertyGroup_form_viewTitle')
    "
    @cancel="toBack"
    delBtn
    :initData="PropertyGroupData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'event_property_group_name',
      'event_property_group_description',
      'event_property_group_code',
      'remarks',
    ]"
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_eventPropertyGroup_list_title')).then(
        (res) => {
          res ? toDelete() : null;
        }
      )
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row align="center" justify="start" class="white lighten-5">
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  maxlength="100"
                  :readonly="!iSEdited"
                  :bindData="PropertyGroupData.event_property_group_name"
                  @change="
                    (valueArr) => {
                      PropertyGroupData.event_property_group_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_eventPropertyGroup_form_eventPropertyGroupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  maxlength="500"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="PropertyGroupData.event_property_group_description"
                  @change="
                    (valueArr) => {
                      PropertyGroupData.event_property_group_description =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_eventPropertyGroup_form_eventPropertyGroupDescriptionLabel'
                    )
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :filled="iSEdited"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :readonly="!iSEdited"
                  :label="
                    $t(
                      'label_essweb_eventPropertyGroup_form_eventPropertyGroupCodeLabel'
                    )
                  "
                  maxlength="100"
                  v-model="PropertyGroupData.event_property_group_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">
                  {{ $t("label_essweb_eventPropertyGroup_form_remarkLabel") }}
                </v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  dense
                  counter="500"
                  :filled="iSEdited"
                  single-line
                  :readonly="!iSEdited"
                  v-model="PropertyGroupData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <PropertyList
            :items="desserts"
            :listdata="PropertyListData"
            @edit="
              (obj) => {
                viewProperty = false;
                toEditProperty(obj);
              }
            "
            @view="
              (obj) => {
                viewProperty = true;
                toEditProperty(obj);
              }
            "
            :canEdit="iSEdited"
          />
        </template>
      </Taber>

      <!-- content -->
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited && curTab == 'tab-1'"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <EditMappingPopup2
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        :curGroupId="$route.params.id"
        :view="viewProperty"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
        @confirm="onEditProperty"
      />
    </template>
    <!-- tools end -->
  </ContentLayout>
</template>
<script>
import EditMappingPopup2 from "@/Page/EssAdmin/Event/EventPropertyGroup/components/EditMappingPopup2.vue";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  name: "newevent",
  components: { EditMappingPopup2 },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  mounted() {
    this.getEventPGDetail();
    this.getPropertyList();
  },
  watch: {},
  data() {
    return {
      curTab: "tab-1",
      isChanged: false,
      taber: [
        "label_essweb_eventPropertyGroup_form_step_generalLabel",
        "label_essweb_eventPropertyGroup_form_step_propertyGroupLabel",
      ],
      iSEdited: true,
      viewProperty: false,
      PropertyListData: null,
      showMappingPopup: false,
      PropertyData: null,
      PropertyGroupData: {
        event_property_group_name: "",
        event_property_group_description: "",
        event_property_group_code: "",
        remarks: "",
      },
      showSelect: false,
      desserts: [],
    };
  },
  methods: {
    getEventPGDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/get-event-property-group-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["event_property_group_name_save"] =
          res.data.event_property_group_name;
        res.data.event_property_group_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.event_property_group_name
        );
        res.data["event_property_group_description_save"] =
          res.data.event_property_group_description;
        res.data.event_property_group_description =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.event_property_group_description
          );
        that.PropertyGroupData = res.data;
      });
    },
    getPropertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property",
        url: "/event-property/get-event-property-list/",
        data: {
          event_property_group_uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    onEditProperty: function (obj, deleteArr, changeList) {
      const that = this;
      this.PropertyData = null;
      // obj["changeList"].map((item) => (item["org_level_uuid"] = "002"));
      that.showMappingPopup = false;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/update-event-property-group-table/",
        data: {
          uuid: this.$route.params.id,
          propertyIds: deleteArr.length ? deleteArr.join(",") : "",
          ess_att_event_property: changeList,
        },
      }).then((res) => {
        that.findTreeItem(that.desserts, obj.property_master_code, changeList);
      });
    },
    findTreeItem: function (tree, code, obj) {
      const that = this;
      tree.some((item) => {
        if (item["property_master_code"] === code) {
          item["changeList"] = obj;
          if (item["changeList"].length == 0) {
            item["value"] = "";
          }

          return true;
        } else {
          if (item.children) {
            that.findTreeItem(item.children, code, obj);
          } else {
          }
        }
      });
    },
    toBack: function () {
      // if (this.iSEdited) {
      //   this.showSelect = false;
      //   this.iSEdited = false;
      // } else {
      this.$router.back();
      // }
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/delete-event-property-group-table/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_eventPropertyGroup_list_deleteEventPropertyGroupSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/update-event-property-group-table/",
        data: {
          uuid: this.$route.params.id,
          event_property_group_name: this.$transCommonLangKey(
            this.PropertyGroupData.event_property_group_name,
            this.PropertyGroupData.event_property_group_name_save
          ),
          event_property_group_description: this.$transCommonLangKey(
            this.PropertyGroupData.event_property_group_description,
            this.PropertyGroupData.event_property_group_description_save
          ),
          event_property_group_code:
            this.PropertyGroupData.event_property_group_code,
          remarks: this.PropertyGroupData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_eventPropertyGroup_list_updateEventPropertyGroupSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
